/**
 * Miles Travel Assistant (MTA) — embeddable destination chat widget.
 *
 * Public API on window.MTA:
 * MTA.init(config)
 * MTA.open(initialPrompt?)
 * MTA.ask(question)              // open + auto-send
 * MTA.prefill(question)
 * MTA.close()
 * MTA.on(event, handler)         // 'open' | 'close' | 'ask' | 'mapopen' | 'mapclose'
 *
 * HTML tag: <mta-ask></mta-ask>
 */

import { MTAElement } from './MTAElement.js';

if (!customElements.get('mta-ask')) {
  customElements.define('mta-ask', MTAElement);
}

const MTA = {
  _config: { language: 'en' },
  _el: null,

  init(config = {}) {
    this._config = { ...this._config, ...config };
    const target = this._config.target
      ? document.querySelector(this._config.target)
      : document.querySelector('mta-ask');
    if (!target) {
      console.warn('[MTA] No <mta-ask> element found. Add <mta-ask></mta-ask> to your page or pass { target: "#myContainer" }.');
      return;
    }
    this._el = target;
    target.setConfig(this._config);
  },

  open(question) {
    this._el?.open(question);
  },

  ask(question) {
    this._el?.ask(question);
  },

  prefill(question) {
    this._el?.prefill(question);
  },

  close() {
    this._el?.close();
  },

  toggle() {
    this._el?.toggle();
  },

  on(event, handler) {
    this._el?.addEventListener('mta:' + event, handler);
  },
};

window.MTA = MTA;

/**
 * Initializes the MTA widget element automatically with standard config bindings.
 */
function bootstrap() {
  if (window.MTAConfig) {
    MTA.init(window.MTAConfig);
  } else {
    MTA.init();
  }

  if (Array.isArray(window.MTAQueue)) {
    window.MTAQueue.forEach(([method, ...args]) => {
      if (typeof MTA[method] === 'function') {
        MTA[method](...args);
      }
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrap, { once: true });
} else {
  bootstrap();
}

window.addEventListener('keydown', (e) => {
  if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
    e.preventDefault();
    MTA.open();
  }
});

export default MTA;